var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11541",
    "data-name": "Rectangle 11541",
    width: 8.037,
    height: 9.501,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Create_User"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create_User",
    "data-name": "Create User",
    clipPath: "url(#clip-Create_User)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    transform: "translate(1 1)",
    fill: "#0069bf",
    stroke: "#0081ea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15659",
    "data-name": "Group 15659",
    transform: "translate(7.981 7.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15605",
    "data-name": "Group 15605",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32501",
    "data-name": "Path 32501",
    d: "M1.18,9.5a3.5,3.5,0,0,1-.419-.136A1.348,1.348,0,0,1,0,8.08,4.082,4.082,0,0,1,.382,6.46,3.989,3.989,0,0,1,2.4,4.487l.181-.079a2.427,2.427,0,0,1-.947-2.442A2.307,2.307,0,0,1,2.5.538,2.423,2.423,0,0,1,5.767.744a2.354,2.354,0,0,1,.676,1.895A2.415,2.415,0,0,1,5.457,4.4c.124.057.24.106.351.162a3.993,3.993,0,0,1,2.028,2.34,3.528,3.528,0,0,1,.195,1.359A1.329,1.329,0,0,1,6.909,9.483a.279.279,0,0,0-.05.018Zm2.841-.729q1.313,0,2.625,0A.611.611,0,0,0,7.3,8.094a3.872,3.872,0,0,0-.038-.434,3.163,3.163,0,0,0-.746-1.628,3.22,3.22,0,0,0-2.03-1.121,3.2,3.2,0,0,0-1.81.251,3.251,3.251,0,0,0-1.531,1.4A3.2,3.2,0,0,0,.734,8.18a.571.571,0,0,0,.131.359.642.642,0,0,0,.54.233H4.021m0-8.042a1.7,1.7,0,1,0,1.709,1.7A1.714,1.714,0,0,0,4.017.73",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32502",
    "data-name": "Path 32502",
    d: "M34.871,213.612H32.256a.642.642,0,0,1-.54-.233.572.572,0,0,1-.131-.359A3.2,3.2,0,0,1,32,211.4a3.25,3.25,0,0,1,1.531-1.4,3.286,3.286,0,0,1,3.84.87,3.163,3.163,0,0,1,.746,1.628,3.866,3.866,0,0,1,.038.434.611.611,0,0,1-.657.678q-1.313,0-2.625,0",
    transform: "translate(-30.85 -204.84)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32503",
    "data-name": "Path 32503",
    d: "M101.25,31.4a1.7,1.7,0,1,1-1.7,1.709,1.714,1.714,0,0,1,1.7-1.709",
    transform: "translate(-97.234 -30.674)",
    fill: "#fff",
    opacity: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUser);
export default __webpack_public_path__ + "static/media/Create User.d74444ba95a14f07df853598f5255bf4.svg";
export { ForwardRef as ReactComponent };